import { Button as MantineButton } from '@mantine/core';
import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';
import type { FC, MouseEventHandler } from 'react';

import styles from './Button.module.css';

const button = cva(styles.root, {
  variants: {
    intent: {
      primary: styles.primary,
      secondary: styles.secondary,
      disabled: styles.disabled,
    },
    size: {
      medium: styles.medium,
    },
  },
  defaultVariants: {
    intent: 'primary',
    size: 'medium',
  },
});

interface ButtonMainProps extends VariantProps<typeof button> {
  text: string;
  loading?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  backgroundColor?: 'white' | 'grey';
}

interface ButtonTypeSubmitProps {
  type: 'submit';
  onClick?: never;
}

interface ButtonTypeButtonProps {
  type: 'button';
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const Button: FC<ButtonMainProps & (ButtonTypeSubmitProps | ButtonTypeButtonProps)> = ({
  text,
  type,
  loading = false,
  intent,
  size,
  fullWidth,
  onClick,
  disabled,
}) => {
  return (
    <MantineButton
      className={button({ intent, size: fullWidth ? null : size })}
      classNames={{ label: styles.label }}
      disabled={disabled}
      fullWidth={fullWidth}
      loading={loading}
      pos="relative"
      radius="xl"
      size="lg"
      type={type}
      onClick={onClick}
    >
      {text}
    </MantineButton>
  );
};
